import {getUserAllFilters} from "../../../api";
import axios from 'axios'
const actions = {
   getUserAllFilters(state2, payload){
    return new Promise(async (resolve)=> {
      let tag = payload.tag
      let x1 = await axios.get(getUserAllFilters(tag))
      resolve(x1.data.tags)
    })

  }
}
export default {
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/filter/filter.js